export type AllsvenskanDivision = "All"; // Single division league

export interface AllsvenskanTeam {
  id: string;
  name: string;
  nameSv: string;
  abbr: string;
  city: string;
  logo: string;
  division: AllsvenskanDivision;
}

// HockeyAllsvenskan team logos from TheSportsDB
const ALLSVENSKAN_LOGOS: Record<string, string> = {
  "almtuna": "https://r2.thesportsdb.com/images/media/team/badge/5q5ljl1656775157.png",
  "aik": "https://r2.thesportsdb.com/images/media/team/badge/hk98e71656775131.png",
  "bjorkloven": "https://r2.thesportsdb.com/images/media/team/badge/rq0ulr1656775185.png",
  "bik": "https://r2.thesportsdb.com/images/media/team/badge/9jrvz01656775172.png",
  "mora": "https://r2.thesportsdb.com/images/media/team/badge/cjk0v71656775287.png",
  "ostersund": "https://r2.thesportsdb.com/images/media/team/badge/3o8c9u1656775310.png",
  "sodertalje": "https://r2.thesportsdb.com/images/media/team/badge/5ey39a1656775340.png",
  "tingsryd": "https://r2.thesportsdb.com/images/media/team/badge/jb1x3k1656775357.png",
  "vastervik": "https://r2.thesportsdb.com/images/media/team/badge/t7yz291656775380.png",
  "vasterasikhockey": "https://r2.thesportsdb.com/images/media/team/badge/vwqewl1656775395.png",
  "vita-hasten": "https://r2.thesportsdb.com/images/media/team/badge/bw3tmu1656775410.png",
  "karlskrona": "https://r2.thesportsdb.com/images/media/team/badge/8x5fgi1656775243.png",
  "kristianstads": "https://r2.thesportsdb.com/images/media/team/badge/kz7j1n1656775262.png",
  "hc-vita-hasten": "https://r2.thesportsdb.com/images/media/team/badge/bw3tmu1656775410.png",
};

const getAllsvenskanLogo = (teamId: string) => ALLSVENSKAN_LOGOS[teamId] ?? "";

export const ALLSVENSKAN_TEAMS: AllsvenskanTeam[] = [
  { id: "almtuna", name: "Almtuna IS", nameSv: "Almtuna IS", abbr: "AIS", city: "Uppsala", logo: getAllsvenskanLogo("almtuna"), division: "All" },
  { id: "aik", name: "AIK Hockey", nameSv: "AIK Hockey", abbr: "AIK", city: "Stockholm", logo: getAllsvenskanLogo("aik"), division: "All" },
  { id: "bjorkloven", name: "IF Björklöven", nameSv: "IF Björklöven", abbr: "IFB", city: "Umeå", logo: getAllsvenskanLogo("bjorkloven"), division: "All" },
  { id: "bik", name: "BIK Karlskoga", nameSv: "BIK Karlskoga", abbr: "BIK", city: "Karlskoga", logo: getAllsvenskanLogo("bik"), division: "All" },
  { id: "mora", name: "Mora IK", nameSv: "Mora IK", abbr: "MIK", city: "Mora", logo: getAllsvenskanLogo("mora"), division: "All" },
  { id: "ostersund", name: "Östersunds IK", nameSv: "Östersunds IK", abbr: "ÖIK", city: "Östersund", logo: getAllsvenskanLogo("ostersund"), division: "All" },
  { id: "sodertalje", name: "Södertälje SK", nameSv: "Södertälje SK", abbr: "SSK", city: "Södertälje", logo: getAllsvenskanLogo("sodertalje"), division: "All" },
  { id: "tingsryd", name: "Tingsryds AIF", nameSv: "Tingsryds AIF", abbr: "TAIF", city: "Tingsryd", logo: getAllsvenskanLogo("tingsryd"), division: "All" },
  { id: "vastervik", name: "Västerviks IK", nameSv: "Västerviks IK", abbr: "VIK", city: "Västervik", logo: getAllsvenskanLogo("vastervik"), division: "All" },
  { id: "vasterasikhockey", name: "Västerås IK", nameSv: "Västerås IK", abbr: "VHIK", city: "Västerås", logo: getAllsvenskanLogo("vasterasikhockey"), division: "All" },
  { id: "vita-hasten", name: "IK Vita Hästen", nameSv: "IK Vita Hästen", abbr: "VH", city: "Norrköping", logo: getAllsvenskanLogo("vita-hasten"), division: "All" },
  { id: "karlskrona", name: "Karlskrona HK", nameSv: "Karlskrona HK", abbr: "KHK", city: "Karlskrona", logo: getAllsvenskanLogo("karlskrona"), division: "All" },
  { id: "kristianstads", name: "Kristianstads IK", nameSv: "Kristianstads IK", abbr: "KRI", city: "Kristianstad", logo: getAllsvenskanLogo("kristianstads"), division: "All" },
  { id: "hc-vita-hasten", name: "HC Vita Hästen", nameSv: "HC Vita Hästen", abbr: "HCVH", city: "Norrköping", logo: getAllsvenskanLogo("hc-vita-hasten"), division: "All" },
];

export const ALLSVENSKAN_DIVISIONS: AllsvenskanDivision[] = ["All"];

export const getAllsvenskanTeamByAbbr = (abbr: string): AllsvenskanTeam | undefined => {
  return ALLSVENSKAN_TEAMS.find((team) => team.abbr === abbr);
};

export const getAllsvenskanTeamsByDivision = (division: AllsvenskanDivision): AllsvenskanTeam[] => {
  return ALLSVENSKAN_TEAMS.filter((team) => team.division === division);
};
